import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { connect } from "react-redux";
import {
  printerSettings,
  printersLoading,
  selectPrinters
} from "../../../../redux/printers/selectors";
import { PRINTERS_ACTIONS } from "../../../../redux/printers/actions";
import { checkPrinterStatus, printZPL } from "../../../../services/printer";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { getPeriods } from "../../../../services/api/periods";
import moment from "moment";
import { defaultDayFormater, defaultError } from "../../../../libs/utils";

class _PrintersOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      periods: [],
      statuses: {}
    };

    this._loadPrinters = this._loadPrinters.bind(this);
    this._getPeriods = this._getPeriods.bind(this);
    this._checkStatus = this._checkStatus.bind(this);
  }

  static propTypes = {
    loadPrinters: PropTypes.func,
    printers: PropTypes.array,
    printersLoading: PropTypes.bool,
    event: PropTypes.object,
    setPrinter: PropTypes.func,
    printerSettings: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this._getPeriods();
  }

  componentDidMount() {
    this._loadPrinters();
  }

  _getPeriods() {
    getPeriods(this.props.event.id).then(response => {
      this.setState({
        periods: response.data
      });
    });
  }

  _loadPrinters() {
    this.props.loadPrinters();
    this.setState({
      statuses: {}
    });
  }

  _checkStatus(printer) {
    checkPrinterStatus(printer)
      .then(response => {
        let newStatusses = {
          ...this.state.statuses
        };

        newStatusses[printer.name] = response;

        this.setState({
          statuses: newStatusses
        });
      })
      .catch(e => {
        defaultError("something went wrong getting the status :(");
      });
  }
  //^FDBCDGMR
  //^FD.1234567BC!

  _testPrint(printer) {
    printZPL(
      printer,
      `^XA

      ^PW300
      ^LL3000
      
      ^FO40,510^GFA,5771,5771,29,Y0IFC,W01KFEJ07FF8,W0MFC0MFC,V07FF8003FF7NFE,U01FFK03KFC7JFC,U0FFM07FM07FFC,T03FCN0CN03FF8,T0FEY03FE,S01F8J07CT07FC,S07EI01JFT0FF,R01F8001KFE001KFCJ01FC,R03EI0MFC03LFEJ07F,R0FC003NF00MFEI01FC,Q01F001OF807MFEI07E,Q03E007OFE01NFC001F8,Q0F800QF80OFI07E,P01F003QFC07NFE001F,P03E00RFE03OF800FC,P0F801SFJ01LFE003E,O01F007SFCK07KF801F,O03E00TFEL07JFE007C,O07C03UFM0KF003E,O0F007UF8L01JFC01F,N01E00VF8M03IFE007C,N03C01VFCN0JF803E,N07807VFEN03IFC01F,N0F00XFO0JF00F8,M01E01XF8N03IF807C,M01C03XFCO0IFC01E,M03C07XFCO03FFE00F,M0380YFEO01IF8078,M0381gFP07FFC03C,M03801YFP03FFE01E,M03C007XF8P0IF00F,M01C001XFCP07FF8078,M01EI07WFCP03FFC03C,N0FI03WFEQ0FFE01E,N07F801XFQ07FF01F,N07F800XFQ03FF80F,L01IFI07WF8P01FFC078,L07FF8I03WF8K07F8I0FFE03C,L0FFC00181WFCJ03IF8007FF01E,K01FJ07C0WFCJ0JFE003FF80F,K03CJ0FE07VFEI01KF801FF807,K038I03FF03VFEI03KFE00FFC078,K078I0IF81WFI07LF007FE03C,K07I07IF80WFI0MFC03FF01E,K07007JF007VF801MFE01FF80E,K0703JFE007VF801NF01FF80F,K0781JFE003VF803NF80FFC078,K0381JFC001VFC03NFC07FE03C,K03C0JF8I0VFC07NFE03FF01C,K01C0JFJ07UFE0PF03FF81E,K01C0JFJ07UFE0PF01FF80F,L0E0IFEJ03UFE0PF80FFC07,L0E0IFCJ01VF1PFC0FFE078,L0E0IFCJ01VF1PFE07FE03C,L0E07FF8K0VFBPFE03FF03C,L0E07FFL07UFBQF03FF81E,L0E0IFL07UFBQF81FF80E,L0E0FFEL03gMF81FFC0F,L0E0FFEL01gMFC0FFE078,L0E0FFCL01gMFC0FFE038,K01E0FFCM0gMFE07FF03C,K01C0FF8I06I07gLFE07FF01C,K01C0FF8I0F8007gMF03FF81E,K01C0FFI03FC003gMF03FFC0E,K03C1FFI07FE001gMF81FFC0F,K0381FFI0IF001gMF81FFE07,K0381FE001IF800gMFC0FFE078,K0783FE003IFC00gMFC0IF03C,K0703FC007IFE007gLFE0IF01C,K0F03FC00FF9FF003gLFE07FF81E,K0E07FC01FF0FF803gLFE07FF80E,J01E07F803FC07FC01gMF07FFC0F,J01C0FF807F803FC00gMF03FFC07,J03C0FF807F001FE00gMF03FFE078,J0380FF00FFI0FF007gKFE03FFE038,J0781FF00FEI0FF807gKFE01IF038,J0703FF01FCI07F803gKFC01IF03C,J0F03FF03F8I03FC01gKF801IF81C,I01E07FF03F8I01FE00gKF001IF81E,I03C07FE03FJ01FE00gJFE001IFC0E,I0380FFE07EK0FF007gIFCI0IFC0F,I0781FFE07EK0FF803gIF8I0IFE07,I0F01FFE0FCK07FC01gIFJ0IFE07,001E03FFE0FCK07FC00gHFCJ0JF038,003C07FFC0FC03FE03FE007gGFK0JF038,00780IFC0F80IF83FF003gFEK0JF03C,00F00IFC1F83IFC1FF800gFL07IF81C,03E01IFC1F87IFE1FFC007XFCL07IF81C,07C03IFC1F0KF1FFE001XFM07IFC0E,0F807IFC1F0KF8IFI07VFN07IFC0E,3F00JFC1F1KF8IF8I0UF8N07IFC0F,3C01JFC3F1KFCIFEI01SF8O07IFE07,7803JFC3F3KFCJFJ01PFCQ07IFE07,7007JFC3E3KFE7IFCK03LFCS07JF078,F01KFC3E3KFE7JFgL07JF038,E03KFC3E3F83FFE7JFEgK07JF038,E07KFC3E3F01FFE7KFgK07JF838,E03KFC3E3E00FFE7JFCgK07JF038,F01KFC3E3E00FFE7JFgL07JF038,7007JFC3E3E00FFE7IFCK0NFS07JF078,7803JFC3F3E00FFCJFJ01PFEQ07IFE07,3C01JFC3F1F01FFCIFCI03SF8O07IFE07,1F00JFC1F1F03FF8IF8001UF8N07IFE0F,0F807IFC1F0FC7FF8IFI07VF8M07IFC0E,07C03IFC1F0KF1FFE001XFM07IFC0E,03E01IFC1F87IFE1FFC007XFEL07IF81E,00F00IFC1F83IFC1FF800gF8K07IF81C,00780IFC0F80IF83FF003gFEK0JF83C,003C07FFC0FC03FE03FE007gGF8J0JF038,001E03FFE0FCK07FC00gHFCJ0JF038,I0F01FFE0FCK07F801gIFJ0IFE078,I0781FFE07EK0FF803gIF8I0IFE07,I0380FFE07EK0FF007gIFCI0IFE07,I03C07FE03FJ01FE00gKF001IFC0E,I01E07FF03F8I03FE01gKF801IFC0E,J0F03FF01F8I03FC01gKF801IF81E,J0703FF01FCI07F803gKFC01IF81C,J0781FF00FEI0FF807gKFE03IF03C,J0380FF80FFI0FF007gLF03IF038,J03C0FF807F801FE00gMF03FFE078,J01C07F807FC03FC01gMF03FFE07,J01E07F803FE07FC01gMF07FFC0F,K0E07FC01FF0FF803gLFE07FFC0E,K0F03FC00FF9FF003gLFE07FF81E,K0703FC007IFE007gLFC0IF81C,K0783FE003IFC00gMFC0IF03C,K0381FE001IF800gMFC0IF038,K0381FFI0IF001gMF81FFE078,K03C1FFI07FE003gMF81FFE07,K01C0FFI03FC003gMF03FFC0F,K01C0FF8I0FI07gMF03FFC0E,K01C0FF8I06I07gLFE07FF81E,K01E0FFCM0gMFE07FF01C,L0E0FFCL01gMFC0IF03C,L0E0FFEL01gMFC0FFE038,L0E0FFEL03gMF81FFE078,L0E0IFL07UFBQF81FFC0F,L0E07FF8K07UFBQF03FF80E,L0E07FF8K0VF3PFE03FF81E,L0E0IFCJ01VF1PFE07FF01C,L0E0IFCJ01VF1PFC0FFE038,L0E0IFEJ03UFE0PF80FFE078,K01C0JFJ07UFE0PF01FFC07,K01C0JFJ0VFE07OF03FF80F,K03C0JF8I0VFC07NFE03FF01E,K0381JFC001VFC03NFC07FF01C,K0781JFE003VF803NF80FFE03C,K0703JFE007VF801NF01FFC078,K07007JF007VF001MFE01FF80F,K07I07IF80WFI0MFC03FF80E,K078I0IF81WFI07LF007FF01E,K038I03FF03VFEI03KFE00FFE03C,K03CJ0FE07VFEI01KF801FFC078,K01FJ07C0WFCJ07IFE003FF807,L0FFC00181WFCJ03IF8007FF80F,L07FFCI03WF8K07F8I0IF01E,L01IFI07WFQ01FFE03C,N07F800XFQ03FFC078,N0FF001WFEQ07FF80F,N0FI03WFEQ0IF01E,M01EI0XFCP03FFE03E,M01C001XFCP07FFC07C,M038007XF8P0IF8078,M03801YFP03IF00F,M0381gFP07FFE01E,M0380YFEO01IF807C,M03C07XFCO03IF00F8,M01C03XF8O0IFE01F,M01E01XF8N03IFC03E,N0F00XFO0JF007C,N07803VFEN03IFE00F8,N03C01VFCN0JFC01E,N01F00VF8M03JF007C,O0F807UFM01JFE00F8,O07C01TFEM0KF801F,O03E00TFCL07JFE007E,O01F007SF8K07KF800F8,P07C01SFJ03LFE003F,P03E00RFE03OFC007C,P01F003QFC07NFE001F8,Q0FC00QF00OF8007E,Q03E003OFE03NFCI0FC,Q01F800OF807MFEI03F,R07C003MFE00NFI01FC,R03FI0MF803LFEJ03F8,S0FC001KFEI07JF8J01FE,S07EI01IFET0FF,S01F8g03FC,T07FY03FF,T01FCM01EN03FF8,U0FF8L07F8L07FFC,U01FF8J03QFE,V07FFC007FF3NFE,W0MFC0MFC,X0KFEJ01FF,Y07FF8,^FS
      
      ^BY4,4,200
      ^FT250,2120
      ^BEB,,Y,N
      ^FD0000000000000}^FS 
      
      ^FO230,720
        ^A0B,50,40
        ^FB1000,1,0,C
        ^FD{{{eventName}}} - {{{period}}}
      ^FS  
      
      ^FO120,720
        ^A0B,121,110
        ^FB1000,1,0,C
        ^FDSPECIEMEN
      ^FS  
      
      ^FO45,720
        ^A0B,60,45
        ^FB1000,1,0,C
        ^FD{{{userFullName}}} | {{{companyName}}}
      ^FS   
      
      ^FO40,2210^GFA,5771,5771,29,Y0IFC,W01KFEJ07FF8,W0MFC0MFC,V07FF8003FF7NFE,U01FFK03KFC7JFC,U0FFM07FM07FFC,T03FCN0CN03FF8,T0FEY03FE,S01F8J07CT07FC,S07EI01JFT0FF,R01F8001KFE001KFCJ01FC,R03EI0MFC03LFEJ07F,R0FC003NF00MFEI01FC,Q01F001OF807MFEI07E,Q03E007OFE01NFC001F8,Q0F800QF80OFI07E,P01F003QFC07NFE001F,P03E00RFE03OF800FC,P0F801SFJ01LFE003E,O01F007SFCK07KF801F,O03E00TFEL07JFE007C,O07C03UFM0KF003E,O0F007UF8L01JFC01F,N01E00VF8M03IFE007C,N03C01VFCN0JF803E,N07807VFEN03IFC01F,N0F00XFO0JF00F8,M01E01XF8N03IF807C,M01C03XFCO0IFC01E,M03C07XFCO03FFE00F,M0380YFEO01IF8078,M0381gFP07FFC03C,M03801YFP03FFE01E,M03C007XF8P0IF00F,M01C001XFCP07FF8078,M01EI07WFCP03FFC03C,N0FI03WFEQ0FFE01E,N07F801XFQ07FF01F,N07F800XFQ03FF80F,L01IFI07WF8P01FFC078,L07FF8I03WF8K07F8I0FFE03C,L0FFC00181WFCJ03IF8007FF01E,K01FJ07C0WFCJ0JFE003FF80F,K03CJ0FE07VFEI01KF801FF807,K038I03FF03VFEI03KFE00FFC078,K078I0IF81WFI07LF007FE03C,K07I07IF80WFI0MFC03FF01E,K07007JF007VF801MFE01FF80E,K0703JFE007VF801NF01FF80F,K0781JFE003VF803NF80FFC078,K0381JFC001VFC03NFC07FE03C,K03C0JF8I0VFC07NFE03FF01C,K01C0JFJ07UFE0PF03FF81E,K01C0JFJ07UFE0PF01FF80F,L0E0IFEJ03UFE0PF80FFC07,L0E0IFCJ01VF1PFC0FFE078,L0E0IFCJ01VF1PFE07FE03C,L0E07FF8K0VFBPFE03FF03C,L0E07FFL07UFBQF03FF81E,L0E0IFL07UFBQF81FF80E,L0E0FFEL03gMF81FFC0F,L0E0FFEL01gMFC0FFE078,L0E0FFCL01gMFC0FFE038,K01E0FFCM0gMFE07FF03C,K01C0FF8I06I07gLFE07FF01C,K01C0FF8I0F8007gMF03FF81E,K01C0FFI03FC003gMF03FFC0E,K03C1FFI07FE001gMF81FFC0F,K0381FFI0IF001gMF81FFE07,K0381FE001IF800gMFC0FFE078,K0783FE003IFC00gMFC0IF03C,K0703FC007IFE007gLFE0IF01C,K0F03FC00FF9FF003gLFE07FF81E,K0E07FC01FF0FF803gLFE07FF80E,J01E07F803FC07FC01gMF07FFC0F,J01C0FF807F803FC00gMF03FFC07,J03C0FF807F001FE00gMF03FFE078,J0380FF00FFI0FF007gKFE03FFE038,J0781FF00FEI0FF807gKFE01IF038,J0703FF01FCI07F803gKFC01IF03C,J0F03FF03F8I03FC01gKF801IF81C,I01E07FF03F8I01FE00gKF001IF81E,I03C07FE03FJ01FE00gJFE001IFC0E,I0380FFE07EK0FF007gIFCI0IFC0F,I0781FFE07EK0FF803gIF8I0IFE07,I0F01FFE0FCK07FC01gIFJ0IFE07,001E03FFE0FCK07FC00gHFCJ0JF038,003C07FFC0FC03FE03FE007gGFK0JF038,00780IFC0F80IF83FF003gFEK0JF03C,00F00IFC1F83IFC1FF800gFL07IF81C,03E01IFC1F87IFE1FFC007XFCL07IF81C,07C03IFC1F0KF1FFE001XFM07IFC0E,0F807IFC1F0KF8IFI07VFN07IFC0E,3F00JFC1F1KF8IF8I0UF8N07IFC0F,3C01JFC3F1KFCIFEI01SF8O07IFE07,7803JFC3F3KFCJFJ01PFCQ07IFE07,7007JFC3E3KFE7IFCK03LFCS07JF078,F01KFC3E3KFE7JFgL07JF038,E03KFC3E3F83FFE7JFEgK07JF038,E07KFC3E3F01FFE7KFgK07JF838,E03KFC3E3E00FFE7JFCgK07JF038,F01KFC3E3E00FFE7JFgL07JF038,7007JFC3E3E00FFE7IFCK0NFS07JF078,7803JFC3F3E00FFCJFJ01PFEQ07IFE07,3C01JFC3F1F01FFCIFCI03SF8O07IFE07,1F00JFC1F1F03FF8IF8001UF8N07IFE0F,0F807IFC1F0FC7FF8IFI07VF8M07IFC0E,07C03IFC1F0KF1FFE001XFM07IFC0E,03E01IFC1F87IFE1FFC007XFEL07IF81E,00F00IFC1F83IFC1FF800gF8K07IF81C,00780IFC0F80IF83FF003gFEK0JF83C,003C07FFC0FC03FE03FE007gGF8J0JF038,001E03FFE0FCK07FC00gHFCJ0JF038,I0F01FFE0FCK07F801gIFJ0IFE078,I0781FFE07EK0FF803gIF8I0IFE07,I0380FFE07EK0FF007gIFCI0IFE07,I03C07FE03FJ01FE00gKF001IFC0E,I01E07FF03F8I03FE01gKF801IFC0E,J0F03FF01F8I03FC01gKF801IF81E,J0703FF01FCI07F803gKFC01IF81C,J0781FF00FEI0FF807gKFE03IF03C,J0380FF80FFI0FF007gLF03IF038,J03C0FF807F801FE00gMF03FFE078,J01C07F807FC03FC01gMF03FFE07,J01E07F803FE07FC01gMF07FFC0F,K0E07FC01FF0FF803gLFE07FFC0E,K0F03FC00FF9FF003gLFE07FF81E,K0703FC007IFE007gLFC0IF81C,K0783FE003IFC00gMFC0IF03C,K0381FE001IF800gMFC0IF038,K0381FFI0IF001gMF81FFE078,K03C1FFI07FE003gMF81FFE07,K01C0FFI03FC003gMF03FFC0F,K01C0FF8I0FI07gMF03FFC0E,K01C0FF8I06I07gLFE07FF81E,K01E0FFCM0gMFE07FF01C,L0E0FFCL01gMFC0IF03C,L0E0FFEL01gMFC0FFE038,L0E0FFEL03gMF81FFE078,L0E0IFL07UFBQF81FFC0F,L0E07FF8K07UFBQF03FF80E,L0E07FF8K0VF3PFE03FF81E,L0E0IFCJ01VF1PFE07FF01C,L0E0IFCJ01VF1PFC0FFE038,L0E0IFEJ03UFE0PF80FFE078,K01C0JFJ07UFE0PF01FFC07,K01C0JFJ0VFE07OF03FF80F,K03C0JF8I0VFC07NFE03FF01E,K0381JFC001VFC03NFC07FF01C,K0781JFE003VF803NF80FFE03C,K0703JFE007VF801NF01FFC078,K07007JF007VF001MFE01FF80F,K07I07IF80WFI0MFC03FF80E,K078I0IF81WFI07LF007FF01E,K038I03FF03VFEI03KFE00FFE03C,K03CJ0FE07VFEI01KF801FFC078,K01FJ07C0WFCJ07IFE003FF807,L0FFC00181WFCJ03IF8007FF80F,L07FFCI03WF8K07F8I0IF01E,L01IFI07WFQ01FFE03C,N07F800XFQ03FFC078,N0FF001WFEQ07FF80F,N0FI03WFEQ0IF01E,M01EI0XFCP03FFE03E,M01C001XFCP07FFC07C,M038007XF8P0IF8078,M03801YFP03IF00F,M0381gFP07FFE01E,M0380YFEO01IF807C,M03C07XFCO03IF00F8,M01C03XF8O0IFE01F,M01E01XF8N03IFC03E,N0F00XFO0JF007C,N07803VFEN03IFE00F8,N03C01VFCN0JFC01E,N01F00VF8M03JF007C,O0F807UFM01JFE00F8,O07C01TFEM0KF801F,O03E00TFCL07JFE007E,O01F007SF8K07KF800F8,P07C01SFJ03LFE003F,P03E00RFE03OFC007C,P01F003QFC07NFE001F8,Q0FC00QF00OF8007E,Q03E003OFE03NFCI0FC,Q01F800OF807MFEI03F,R07C003MFE00NFI01FC,R03FI0MF803LFEJ03F8,S0FC001KFEI07JF8J01FE,S07EI01IFET0FF,S01F8g03FC,T07FY03FF,T01FCM01EN03FF8,U0FF8L07F8L07FFC,U01FF8J03QFE,V07FFC007FF3NFE,W0MFC0MFC,X0KFEJ01FF,Y07FF8,^FS
      
      ^XZ`
    );
  }

  _handlePrinterChange(periodId, day, printerName) {
    this.props.setPrinter(periodId, day, printerName);
  }

  render() {
    let { printers, printersLoading, printerSettings } = this.props;
    const { periods, statuses } = this.state;

    if (printers && typeof printers === "object") {
      printers = Object.values(printers);
    } else if (printers && typeof printers !== "object") {
      printers = [];
    }

    let daysInPeriod = [];
    periods.forEach(period => {
      daysInPeriod[period.id] = [];
      const start = moment(period.startsAt);
      const end = moment(period.endsAt);
      while (start < end) {
        daysInPeriod[period.id].push(start.format("YYYY-MM-DD"));
        start.add(1, "day");
      }
    });

    let printerNames = [];

    if (printers) printerNames = printers.map(printer => printer.name);

    return [
      <AdminSubHeader title="Printers" key="subheader" breadcrumbs={[]}>
        <button
          onClick={this._loadPrinters}
          className={
            "btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air " +
            (printersLoading ? "loading" : "")
          }
        >
          <i className="la la-refresh" />
        </button>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-lg-6">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-list-3" />
                    </span>
                    <h3 className="m-portlet__head-text">Printer / Bracelet</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                {periods &&
                  periods.map(period => (
                    <div key={period.id}>
                      <h3>{period.name}</h3>
                      <table className="table m-form m-form--state">
                        <tbody>
                          <tr>
                            <td>Combi</td>
                            <td
                              className={
                                printerSettings[period.id] &&
                                printerSettings[period.id]["combi"] &&
                                printerNames.indexOf(
                                  printerSettings[period.id]["combi"]
                                ) === -1
                                  ? "has-danger"
                                  : ""
                              }
                            >
                              <select
                                name=""
                                id=""
                                className="form-control m-input m-input--square"
                                onChange={e =>
                                  this._handlePrinterChange(
                                    period.id,
                                    "combi",
                                    e.target.value
                                  )
                                }
                                value={
                                  printerSettings[period.id] &&
                                  printerSettings[period.id]["combi"]
                                    ? printerSettings[period.id]["combi"]
                                    : ""
                                }
                              >
                                <option value="">No Printer Selected</option>
                                {printerSettings[period.id] &&
                                  printerSettings[period.id]["combi"] &&
                                  printerNames.indexOf(
                                    printerSettings[period.id]["combi"]
                                  ) === -1 && (
                                    <option
                                      value={
                                        printerSettings[period.id]["combi"]
                                      }
                                      disabled
                                    >
                                      {printerSettings[period.id]["combi"]}
                                    </option>
                                  )}
                                {printers &&
                                  printers.map(printer => (
                                    <option
                                      key={printer.name}
                                      value={printer.name}
                                    >
                                      {standardizeName(printer.name)}
                                    </option>
                                  ))}
                              </select>
                            </td>
                          </tr>
                          {period.type !== "buildbreak" &&
                            daysInPeriod[period.id].map(day => (
                              <tr key={day}>
                                <td>{defaultDayFormater(day)}</td>
                                <td
                                  className={
                                    printerSettings[period.id] &&
                                    printerSettings[period.id][day] &&
                                    printerNames.indexOf(
                                      printerSettings[period.id][day]
                                    ) === -1
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <select
                                    name=""
                                    id=""
                                    className="form-control m-input m-input--square"
                                    onChange={e =>
                                      this._handlePrinterChange(
                                        period.id,
                                        day,
                                        e.target.value
                                      )
                                    }
                                    value={
                                      printerSettings[period.id] &&
                                      printerSettings[period.id][day]
                                        ? printerSettings[period.id][day]
                                        : ""
                                    }
                                  >
                                    <option value="">
                                      No Printer Selected
                                    </option>
                                    {printerSettings[period.id] &&
                                      printerSettings[period.id][day] &&
                                      printerNames.indexOf(
                                        printerSettings[period.id][day]
                                      ) === -1 && (
                                        <option
                                          value={
                                            printerSettings[period.id][day]
                                          }
                                          disabled
                                        >
                                          {printerSettings[period.id][day]}
                                        </option>
                                      )}
                                    {printers &&
                                      printers.map(printer => (
                                        <option
                                          key={printer.name}
                                          value={printer.name}
                                        >
                                          {standardizeName(printer.name)}
                                        </option>
                                      ))}
                                  </select>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-list-3" />
                    </span>
                    <h3 className="m-portlet__head-text">Downloads</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                <a
                  className="btn btn-block m-btn m-btn--icon btn-outline-warning"
                  href="https://static-feed.tomorrowland.com/cas/downloads/zebra-browser-print-mac-v131445.dmg"
                >
                  <span>
                    <i className="la la-apple" />
                    <span>Mac Installer</span>
                  </span>
                </a>
                <a
                  className="btn btn-block m-btn m-btn--icon btn-outline-warning"
                  href="https://static-feed.tomorrowland.com/cas/downloads/zebra-browser-print-windows-v131445.exe"
                >
                  <span>
                    <i className="la la-windows" />
                    <span>Windows Installer</span>
                  </span>
                </a>
                <a
                  className="btn btn-block m-btn m-btn--icon btn-outline-warning"
                  href="https://static-feed.tomorrowland.com/cas/downloads/CAS+-+Browser+Print+macOS+Install.pdf"
                >
                  <span>
                    <i className="la la-stack-overflow" />
                    <span>Manual - MacOS</span>
                  </span>
                </a>
                <a
                  className="btn btn-block m-btn m-btn--icon btn-outline-warning"
                  href="https://cdn.assets.tomorrowland.com/cas/downloads/2018/HandleidingWindows.pdf"
                >
                  <span>
                    <i className="la la-stack-overflow" />
                    <span>Manual - Windows [Outdated]</span>
                  </span>
                </a>
              </div>
            </div>
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-list-3" />
                    </span>
                    <h3 className="m-portlet__head-text">Connected Printers</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                {printers ? (
                  <table className="table m-table">
                    <thead>
                      <tr>
                        <th>Printer Name</th>
                        <th>Status</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {printers.map(printer => (
                        <tr key={printer.name}>
                          <td>{standardizeName(printer.name)}</td>
                          <td>
                            {statuses[printer.name]
                              ? statuses[printer.name].join(", ")
                              : ""}
                          </td>
                          <td className="m--align-right">
                            <button
                              className="btn btn-outline-accent btn-sm 	m-btn m-btn--icon m--margin-right-5"
                              onClick={() => this._checkStatus(printer)}
                            >
                              <span>
                                <i className="la la-refresh" />
                                <span>Status</span>
                              </span>
                            </button>
                            <button
                              className="btn btn-outline-accent btn-sm 	m-btn m-btn--icon"
                              onClick={() => this._testPrint(printer)}
                            >
                              <span>
                                <i className="la la-print" />
                                <span>Test Print</span>
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="alert alert-danger">
                    No printers connected
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapStateToProps = function(state) {
  return {
    printers: selectPrinters(state),
    printersLoading: printersLoading(state),
    event: selectEvent(state),
    printerSettings: printerSettings(state)
  };
};

const mapDispatchToProps = dispatch => ({
  loadPrinters: () => dispatch(PRINTERS_ACTIONS.loadPrinters()),
  setPrinter: (periodId, day, printerName) =>
    dispatch(PRINTERS_ACTIONS.setPrinterForDay(periodId, day, printerName))
});

const PrintersOverview = connect(
  mapStateToProps,
  mapDispatchToProps
)(_PrintersOverview);

export default PrintersOverview;

function standardizeName(name) {
  if (!name) return name
  if (name.startsWith('usb#')) {
    // eg usb#vid_0a5f&pid_008b#JDI092607#bus_001#addr_007
    return name.split('#')[2] ?? 'unknown'
  }
  return name
}
